import {inject, Injectable} from '@angular/core';

import {BookingUpdatedEvent} from '../../../../../shared/application/events/booking/booking-updated.event';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {Booking} from '../../domain/models/booking.model';
import {deepClone} from '../../../../../shared/utils/object.utils';

@Injectable({providedIn: 'root'})
export class UpdateBookingUseCase {
  private readonly eventBus = inject(EVENT_BUS);

  execute(booking: Booking | null, accountAmount: number): void {
    if (!booking || booking.currentConsumption === accountAmount) {
      return;
    }

    booking.registerConsumption(accountAmount);

    this.eventBus.publish(
      new BookingUpdatedEvent(deepClone(booking), true)
    );
  }
}
